var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTooltipClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_750_1971)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67282 12.7383C6.5101 12.9011 6.5101 13.1649 6.67282 13.3276C6.83554 13.4903 7.09936 13.4903 7.26208 13.3276L10.0005 10.5892L12.7389 13.3276C12.9016 13.4903 13.1654 13.4903 13.3282 13.3276C13.4909 13.1649 13.4909 12.9011 13.3282 12.7383L10.5897 9.99992L13.328 7.26171C13.4907 7.09899 13.4907 6.83517 13.328 6.67245C13.1652 6.50974 12.9014 6.50974 12.7387 6.67245L10.0005 9.41066L7.26228 6.67245C7.09956 6.50974 6.83574 6.50974 6.67302 6.67245C6.5103 6.83517 6.5103 7.09899 6.67302 7.26171L9.41123 9.99992L6.67282 12.7383Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_750_1971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTooltipClose);
export default __webpack_public_path__ + "static/media/ic_tooltip_close.7e33d371ecf9ebae4a4b70d2ca0fcf7c.svg";
export { ForwardRef as ReactComponent };